import { Internal_CheckPermissions } from "@swivl-mono/helpers";
import { APIScope } from "@swivl-mono/types";
import RolesModel from "../../Models/Roles/Roles.Model";
import AccountModel from "../../Models/Account/AccountModel";

export function HasPermission(
        action:APIScope, 
        orgId: number,
        groupId?: number,
        locationId?: number,
    ):boolean {
        const {parentRoles, roles} = RolesModel.state
        const member = AccountModel.state.member
        if (!member || !roles) {return false;}
        return Internal_CheckPermissions(parentRoles, roles, member.permissions, action, member.orgId, groupId, locationId)
}